// PieChart.tsx
import { FC } from 'react'
import { Pie } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartOptions,
} from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

type Props = {
  comTaxas: number
  semTaxas: number
  height?: number
}

const options: ChartOptions<'pie'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { position: 'bottom' } },
}

const PieChart: FC<Props> = ({ comTaxas, semTaxas, height = 160 }) => {
  const data = {
    labels: ['Com taxas', 'Sem taxas'],
    datasets: [
      {
        data: [comTaxas, semTaxas],
        backgroundColor: ['#6381E8', '#F54E5B'],
        borderWidth: 0,
      },
    ],
  }

  return (
    <div style={{ height }}>
      <Pie data={data} options={options} />
    </div>
  )
}

export default PieChart
